import React from 'react'

export default function Message({ children }) {
    return (
        <p className='fixed top-0 left-0 w-full z-10 text-center p-3 bg-[#c7c7c7] text-red-500 font-medium'>
            {children}
        </p>
    )
}
